export const fileToBase64 = (file: File): Promise<string> =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.readAsDataURL(file);
    reader.onload = () => {
      const base64String =
        typeof reader.result === 'string' &&
        reader.result?.replace('data:', '').replace(/^.+,/, '');
      base64String ? resolve(base64String || '') : reject(Error('No data.'));
    };
    reader.onerror = (error) => reject(error);
  });
